import { PRO_BUYER_SEARCH_FILTER_PARAM } from "@/features/pro-buyer-price/static/pro-buyer-price.static";
import type { SearchResponse } from "@/features/search/api/queries";
import { isTermsFacet } from "@/features/search/api/types";

/**
 * WHO-5953. Items in the current search, category and filters with a Pro Buyer
 * price: the `true` bucket of the search service's
 * `merchant_trade_discount_enabled` facet. With the filter on, the service's
 * disjunctive search keeps that bucket counted over the unfiltered results, so
 * it equals the shown total.
 *
 * Fail-soft: a service without the facet yet returns null (no strip), except
 * when the filter is on, where the total already is the count.
 */
export const getProBuyerCount = (
  data: SearchResponse | undefined,
  filterOn = false
): number | null => {
  if (!data) {
    return null;
  }

  const facet = data.facets.find(
    candidate => candidate.key === PRO_BUYER_SEARCH_FILTER_PARAM
  );

  if (facet && isTermsFacet(facet)) {
    return facet.values.find(value => value.value === "true")?.count ?? 0;
  }

  return filterOn ? data.pageInfo.total : null;
};
